













import { Component, Vue } from 'vue-property-decorator'
import Choir from './about/Choir.vue'
import Conductors from './about/Conductors.vue'
import Exco from './about/Exco.vue'

@Component({
  components: {
    Choir,
    Conductors,
    Exco
  }
})
export default class About extends Vue {}
